import uaParser from 'ua-parser-js'

var DeviceDetector = (function () {
  var ua = navigator.userAgent
  var parser = uaParser(ua)

  return {
    deviceType: deviceType(),
    isAndroid: isAndroid(),
    isIos: isIos(),
    ua: ua,
    osName: osName(),
    osVersion: osVersion(),
    browserName: browser(),
    browserVersion: browserVersion(),
    isCrawlerBot: isCrawlerBot()
  }

  function deviceType () {
    if (parser.device) {
      return parser.device.type
    }
  }

  function browser () {
    if (parser.browser) {
      // console.log('browser:', parser.browser.name)
      // console.log('device:', parser.device.type)
      if (parser.browser.name === 'IE') {
        document.body.className += ' ' + 'ie'
      } else if (parser.browser.name === 'Edge') {
        document.body.className += ' ' + 'edge'
      } else if (parser.browser.name === 'Safari') {
        document.body.className += ' ' + 'safari'
      }
      return parser.browser.name
    }
  }

  function browserVersion () {
    if (parser.browser) {
      return parser.browser.version
    }
  }

  function osName () {
    if (parser.os) {
      return parser.os.name
    }
  }

  function osVersion () {
    if (parser.os) {
      return parser.os.version
    }
  }

  function isIos () {
    if (parser.os) {
      return parser.os.name === 'iOS'
    }
  }

  function isAndroid () {
    if (parser.os) {
      return parser.os.name === 'Android'
    }
  }

  function isCrawlerBot () {
    return /bot|google|facebookexternalhit|facebot|baidu|bing|msn|duckduckgo|teoma|slurp|yandex/i.test(ua)
  }
}())

export default DeviceDetector



// WEBPACK FOOTER //
// ./src/helpers/device/deviceDetector.js